module.exports = __webpack_public_path__ + "static/img/terrazas.3a6e00b8.jpg";